export default __webpack_public_path__ + "static/media/SharkNovels.0721a75e.png";